import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    project: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // For now, just show success message
    // In production, this would send to a backend endpoint
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', project: '' });
    }, 5000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="min-h-screen py-24 md:py-32 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        {/* Heading - Larger */}
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-light text-[#2C2C2C] lowercase mb-12">
          {t('contact.heading')}
        </h1>

        {/* Lead line */}
        <p className="text-3xl md:text-4xl font-light text-[#2C2C2C] mb-20">
          {t('contact.lead')}
        </p>

        <div className="grid md:grid-cols-2 gap-16 mb-20">
          {/* Left - Contact details */}
          <div className="space-y-12">
            {/* Email */}
            <div>
              <a 
                href={`mailto:${t('contact.email')}`}
                className="text-xl font-light text-[#2C1810] hover:opacity-70 transition-opacity duration-300 border-b border-[#2C1810]"
              >
                {t('contact.email')}
              </a>
            </div>

            {/* Phone */}
            <div>
              <a 
                href={`tel:${t('contact.phone')}`}
                className="text-xl font-light text-[#2C1810] hover:opacity-70 transition-opacity duration-300 border-b border-[#2C1810]"
              >
                {t('contact.phone')}
              </a>
            </div>

            {/* Instagram */}
            <div>
              <a 
                href={t('contact.instagramUrl')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xl font-light text-[#2C1810] hover:opacity-70 transition-opacity duration-300 border-b border-[#2C1810]"
              >
                {t('contact.instagram')}
              </a>
            </div>

            {/* Studio Sofia */}
            <div>
              <h3 className="text-lg font-light text-[#2C2C2C] mb-2">
                {t('contact.studio.heading')}
              </h3>
              <p className="text-lg font-light text-[#5A5A5A]">
                {t('contact.studio.address1')}
              </p>
              <p className="text-lg font-light text-[#5A5A5A]">
                {t('contact.studio.address2')}
              </p>
            </div>

            {/* Milano */}
            <div>
              <h3 className="text-lg font-light text-[#2C2C2C] mb-2">
                {t('contact.also.heading')}
              </h3>
              <p className="text-lg font-light text-[#5A5A5A]">
                {t('contact.also.location')}
              </p>
            </div>
          </div>

          {/* Right - Contact form */}
          <div>
            {submitted ? (
              <div className="p-8 bg-[#F6F4F1] text-center">
                <p className="text-xl font-light text-[#2C2C2C]">
                  {t('contact.form.success')}
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={t('contact.form.name')}
                    required
                    className="w-full px-0 py-3 border-b border-[#2C2C2C] bg-transparent text-lg font-light text-[#2C2C2C] placeholder-[#5A5A5A] focus:outline-none focus:border-[#2C1810]"
                  />
                </div>

                <div>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t('contact.form.email')}
                    required
                    className="w-full px-0 py-3 border-b border-[#2C2C2C] bg-transparent text-lg font-light text-[#2C2C2C] placeholder-[#5A5A5A] focus:outline-none focus:border-[#2C1810]"
                  />
                </div>

                <div>
                  <textarea
                    name="project"
                    value={formData.project}
                    onChange={handleChange}
                    placeholder={t('contact.form.project')}
                    required
                    rows="6"
                    className="w-full px-0 py-3 border-b border-[#2C2C2C] bg-transparent text-lg font-light text-[#2C2C2C] placeholder-[#5A5A5A] focus:outline-none focus:border-[#2C1810] resize-none"
                  />
                </div>

                <button
                  type="submit"
                  className="text-lg font-light text-[#2C1810] lowercase hover:opacity-70 transition-opacity duration-300"
                >
                  {t('contact.form.submit')}
                </button>
              </form>
            )}

            {/* Footer note */}
            <p className="text-sm font-light text-[#5A5A5A] mt-8">
              {t('contact.form.footer')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
